import React, { useEffect, useState } from 'react';
import Page, { usePage } from '../../components/Page';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { SideBar, useSideBar } from '../../components/SideBar';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-regular-svg-icons';
import { grey } from '@mui/material/colors';

export const NoMatchPage = (): React.ReactElement => {
    const page = usePage();
    const navigate = useNavigate();
    const sideBar = useSideBar();
    const [pageTitle, setPageTitle] = useState('');
    const [navTitle, setNavTitle] = useState('');
    useEffect(() => {
        setTimeout(() => {
            setPageTitle('NoMatch');
            setNavTitle('找不到頁面');
            page.setIsLoading(false);
        }, 3000);
    }, []);

    return (
        <Page {...page} title={pageTitle}>
            <Grid container flexDirection={'row'} height={'100%'}>
                {page.isLoading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100vh', // Full height of the viewport
                            flex: 1,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <div style={{ flex: 1, backgroundColor: grey[100] }}>
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant='h1'>{'Oops'}</Typography>
                            <Typography variant='h5'>{'404 - PAGE NOT FOUND'}</Typography>
                            <Button variant='contained' color='primary' style={{ borderRadius: 20 }} onClick={() => navigate('/home')}>
                                {'GO TO HOMEPAGE'}
                            </Button>
                        </div>
                    </div>
                )}
            </Grid>
        </Page>
    );
};
